/*
*
* ***********************************Example of Usage***********************************
*
* 1 - Simple usage
*    <InputText value={this.state.value} onChange={this.handleOnChangeValue} />
*
* 2 - Placeholder
*    <InputText placeholder="Write Here" value="Erase me to show placeholder"
*               onChange={this.handleOnChangeValue}/>
*
* 3 - Trigger events functions (Available: onBlur, onFocus and onChange)
*    <InputText value={this.state.value} onChange={this.handleOnChangeValue}
*               onFocus={this.handleFocus} onBlur={this.handleBlur}/>
*
* 4 - Change its size (Defaults to medium)
*    <InputText value={this.state.value} onChange={this.handleOnChangeValue} size="small" />
*
* 5 - Masked currency
*    <InputText value={this.state.value2} onComponentDidUpdate={this.handleComponentUpdate}
*               applyTextFilter={this.applyCurrency} onChange={this.handleOnChangeValue2} />
*
* 6 - Max length
*    <InputText value={this.state.value} maxLength={30} />
*
* 6 - Call onKeydown
*    <InputText value={this.state.value} onChange={this.handleOnChangeValue}
*               onKeyDown={this.props.onKeyDown}/>
*
* Note: to use this component you may need some of this functions
*   getInitialState: function() { return { Currency.currencyMask(value: "02") }; },
*   handleOnChangeValue: function(e) { this.setState({ value: Currency.currencyMask(e.target.value) }); },
*   handleComponentUpdate: function(prevState, newState, caretPosition, node) {
*     Currency.calculateNewCaretPosition(prevState, newState, caretPosition, node);
*   },
*
*/

"use strict";

var cx = require("classnames");
var PureRenderMixin = React.addons.PureRenderMixin;

var InputText = React.createClass({
  mixins: [PureRenderMixin],
  propTypes: {
    className: React.PropTypes.string,
    id: React.PropTypes.string,
    maxLength: React.PropTypes.number,
    onBlur: React.PropTypes.func,
    onChange: React.PropTypes.func.isRequired,
    onComponentDidUpdate: React.PropTypes.func,
    onFocus: React.PropTypes.func,
    onKeyDown: React.PropTypes.func,
    placeholder: React.PropTypes.string,
    size: React.PropTypes.oneOf(["small", "medium", "large"]),
    value: React.PropTypes.string,
    visibleBorders: React.PropTypes.bool
  },
  getDefaultProps: function() {
    return {
      size: "medium",
      visibleBorders: true
    };
  },
  componentDidUpdate: function(prevProps, prevState){
    if (this.props.onComponentDidUpdate) {
      this.props.onComponentDidUpdate(prevProps, this.props, this.refs["inputText"]);
    }
  },
  handleOnChange: function(e) {
    if (typeof this.props.onChange === "function") {
      if (this.props.maxLength) {
        this.applyMaxLength(e.target);
      }
      this.props.onChange(e);
    }
  },
  applyMaxLength: function(target) {
    var currentCursorPosition = target.selectionStart;
    target.value = this.cropText(target.value);

    // after target.value is changed, cursor moves to the beginning of the text
    // this is necessary to keep the cursor in the same position
    target.selectionStart = currentCursorPosition;
  },
  cropText: function(value) {
    var maxLength = this.props.maxLength;

    if (value.length <= maxLength) {
      return value;
    } else {
      value = value.substring(0, maxLength);
      return value;
    }
  },
  render: function(){
    var className = cx(
      "inputText",
      "inputText--" + this.props.size,
      {
        [`${this.props.className}`]: this.props.className,
        "inputText--invisible": !this.props.visibleBorders
      });

    return (
      <input ref="inputText" type="text"
              id={this.props.id}
              className={className}
              onChange={this.handleOnChange}
              onFocus={this.props.onFocus}
              onBlur={this.props.onBlur}
              value={this.props.value}
              placeholder={this.props.placeholder}
              onKeyDown={this.props.onKeyDown}></input>
    );
  }
});

module.exports = InputText;



// WEBPACK FOOTER //
// ./app/shared/components/InputText/input-text.jsx